import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-assigned-givi',
    templateUrl: './assigned-givi.component.html',
    styleUrls: ['./assigned-givi.component.scss']
})
export class AssignedGiviComponent implements OnInit {

    @ViewChild('assignedGivi', { static: true }) assignedModal: TemplateRef<any>;

    @Input() isGiver: boolean = false;
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

    progress = 0;
    secondsElapsed = '';
    hasLeave = false;
    
    constructor(public modalService: NgbModal,
        private router: Router,) { }
    
    ngOnInit() {

        this.modalService.dismissAll();

        const modalRef = this.modalService.open(this.assignedModal, {
            backdrop: 'static', keyboard: false,
            centered: true, windowClass: 'modal-full'
        });

        modalRef.result.finally(() => {
            this.hasLeave = true;
            this.close.emit();
        });

        if(!this.isGiver) this.startProgress();
    }

    onClose(){

        this.modalService.dismissAll();
    }

    onGoToGivis(){

        this.router.navigate(['/givis']);
        this.modalService.dismissAll();
    }

    startProgress() {
        const interval = 100; // actualización cada 100ms
        const duration = 10000; // duración total de 10 segundos
    
        setTimeout(() => {
            if (this.hasLeave) return;
            else this.onGoToGivis();
        }, 10500);
        
        const step = (interval / duration) * 100;
        let remainingTime = duration / 1000;
    
        const timer = setInterval(() => {
            this.progress += step;
            
            remainingTime -= interval / 1000; 
            this.secondsElapsed = remainingTime.toFixed(0); 
    
            if (this.progress >= 100 || remainingTime <= 0) {
                
                clearInterval(timer);
                this.secondsElapsed = '0';
            }
        }, interval);
    }
    

}
